import styled from "styled-components";
import { Table } from "react-bootstrap";

export const ListWrapper = styled.div`
    .react-grid-Main {
        border-bottom: 1px solid #ddd;

        outline: 1px solid white;

        .react-grid-Grid {
            border: 1px solid white;

            .react-grid-HeaderCell {
                border-right: 1px solid white;
                padding-top: 4px;
                padding-bottom: 4px;
                /*background-color: #003;
                color: white;*/
            }

            .react-grid-HeaderCell-sortable {
                bottom: 4px;
                position: absolute;
                width: 90%
            }

            .widget-HeaderCell__value {
                bottom: 4px;
                position: absolute;
                width: 90%
            }

            .react-grid-Cell:focus {
                outline: none;
            }
        }

        .rdg-selected {
            /* border: 2px solid #66afe9; */
            border: none;
        }
    }
`;

interface ITableWrapperProps {
    textAlign?: string
}

export const TableWrapper = styled(Table) <ITableWrapperProps>`
    thead th { 
        background-color: #133666;
        color: #FFF;
    }

    thead th:first-child {
        border-radius: 4px 0 0 0px;
    }

    thead th:last-child { 
        border-radius: 0 4px 0px 0;
    }

    & > thead > tr > th {
        border: none !important;
    }

    & > tbody > tr:first-child > td,
    & > tbody > tr:first-child > th {
        border-top: none;
    }

    & > thead > tr > th,
    & > tbody > tr> td {
        font-size: 14px;
        vertical-align: middle;
        text-align: ${p => p.textAlign ? p.textAlign : 'center'};

        select.form-control {
            font-size: 14px !important;
        }

        input.form-control {
            font-size: 14px !important;
        }
    }
`;

export const AdminListWrapper = styled.div`
    .popover {
        max-width: 650px !important;
    }

    .popover > .popover-content {
        max-width: 650px;
    }

    .ag-theme-bootstrap .ag-header-row {
        color: white;
    }
`;

export const GridWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '74vh'};

    .action-menu {
        overflow: visible;
        // border-bottom: none;
        line-height: 25px;
        // border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu.ag-cell-focus {
        // border-top: 1px solid #ccc !important;
        // border-right: 1px solid white !important;
        // border-bottom: 1px solid white !important;
        // border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.headerBgColor ? p.headerBgColor : '#133366'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'} !important;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
        font-size: ${p => p.fontSize ? p.fontSize : '14px'};
    }

    .ag-header-cell::after {
        border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
    }

    .list-cell {
        text-align: center;
        //line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: ${p => p.fontSize ? p.fontSize : '14px'};
    }

    .list-cell-full {
        text-align: center;
        //line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .list-cell-full > .ag-react-container {
        width: 100%;
    }

    .list-cell-left {
        text-align: left;
        // line-height: 28px;
        display: flex;
        align-items: center;
        font-size: ${p => p.fontSize ? p.fontSize : '14px'};
    }

    .list-cell-dropdown {
        // line-height: 28px;
        display: flex;
        align-items: center;
        // padding-top: 3px;
        justify-content: center;
    }

    .customSortUpLabel > span,
    .customSortDownLabel > span {
        margin-left: 3px !important;
    }
`;

export const TagsWrapper = styled.div`
    & .react-tags {
        position: relative;
        padding: 6px 0 0 6px;
        border: 1px solid #ccc;
        border-radius: 4px;
    
        /* shared font styles */
        font-size: 1em;
        line-height: 1.2;
    
        /* clicking anywhere will focus the input */
        cursor: text;
    }
    
    & .react-tags.is-focused {
        border-color: #B1B1B1;
    }
    
    & .react-tags__selected {
        display: inline;
    }
    
    & .react-tags__selected-tag {
        display: inline-block;
        box-sizing: border-box;
        margin: 0 6px 6px 0;
        padding: 6px 8px;
        border: 1px solid #99B18F;
        border-radius: 13px;
        background: #A3C595;
        font-weight: 500;
    
        /* match the font styles */
        font-size: inherit;
        line-height: inherit;
    }
    
    & .react-tags__selected-tag:after {
        content: '\\2716';
        color: #5C7F4E;
        margin-left: 8px;
    }
    
    & .react-tags__selected-tag:hover,
    & .react-tags__selected-tag:focus {
        border-color: #B1B1B1;
    }
    
    & .react-tags__search {
        display: inline-block;
    
        /* match tag layout */
        padding: 7px 2px;
        margin-bottom: 6px;
    
        /* prevent autoresize overflowing the container */
        max-width: 100%;
    }
    
    @media screen and (min-width: 30em) {
    
        & .react-tags__search {
        /* this will become the offsetParent for suggestions */
        position: relative;
        }
    
    }
    
    & .react-tags__search input {
        /* prevent autoresize overflowing the container */
        max-width: 100%;
    
        /* remove styles and layout from this element */
        margin: 0;
        padding: 0;
        border: 0;
        outline: none;
    
        /* match the font styles */
        font-size: inherit;
        line-height: inherit;
    }
    
    & .react-tags__search input::-ms-clear {
        display: none;
    }
    
    & .react-tags__suggestions {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
    }
    
    @media screen and (min-width: 30em) {
        & .react-tags__suggestions {
            width: 240px;
        }
    }
    
    & .react-tags__suggestions ul {
        margin: 4px -1px;
        padding: 0;
        list-style: none;
        background: white;
        border: 1px solid #D1D1D1;
        border-radius: 2px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }
    
    & .react-tags__suggestions li {
        border-bottom: 1px solid #ddd;
        padding: 6px 8px;
    }
    
    & .react-tags__suggestions li mark {
        text-decoration: underline;
        background: none;
        font-weight: 600;
    }
    
    & .react-tags__suggestions li:hover {
        cursor: pointer;
        background: #eee;
    }
    
    & .react-tags__suggestions li.is-active {
        background: #b7cfe0;
    }
    
    & .react-tags__suggestions li.is-disabled {
        opacity: 0.5;
        cursor: auto;
    }
`;

export const FilterDrawerWrapper = styled.div`
    /* border: 1px solid pink; */
    margin-bottom: 5px;

    display: flex;
    /* justify-content: space-between; */
    // margin-bottom: 5px;

    .filter-item {
        display: flex;
        align-items: center;
        margin-right: 20px;
    }

    .filter-item-label {
        margin-right: 5px;
    }

    .filter-label {
        font-size: 12px;
        margin-right: 5px;
    }
`;

export const DonorConnectTicketsWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '74vh'};

    .ag-header {
        background-color: ${p => p.headerBgColor != null ? p.headerBgColor : '#123'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'} !important;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
    }

    .list-cell {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: ${p => p.fontSize ? p.fontSize : '14px'};
    }

    .list-cell-full {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .list-cell-full > .ag-react-container {
        width: 100%;
    }

    .list-cell-left {
        text-align: left;
        display: flex;
        align-items: center;
        line-height: normal;
        font-size: ${p => p.fontSize ? p.fontSize : '14px'};
    }

    .list-cell-dropdown {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .customSortUpLabel > span,
    .customSortDownLabel > span {
        margin-left: 3px !important;
    }
`;

export const FilterTableWrapper = styled(Table)`
    width: initial;
    margin-bottom: 0px;

    & > tbody > tr > td {
        vertical-align: middle;
        border-top: 0 none;
    }
`;